import {type InputWrapperProps} from './types';

export function getMessageId(
  messageId: string,
  {error, hint, hideError}: Pick<InputWrapperProps, 'error' | 'hint' | 'hideError'>,
) {
  return !hideError && (error || hint) ? messageId : undefined;
}
